import { render, staticRenderFns } from "./FrequencySettingsYearly.vue?vue&type=template&id=030f3354"
import script from "./FrequencySettingsYearly.vue?vue&type=script&lang=ts"
export * from "./FrequencySettingsYearly.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('030f3354')) {
      api.createRecord('030f3354', component.options)
    } else {
      api.reload('030f3354', component.options)
    }
    module.hot.accept("./FrequencySettingsYearly.vue?vue&type=template&id=030f3354", function () {
      api.rerender('030f3354', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/frequency/FrequencySettingsYearly.vue"
export default component.exports